module.exports = __webpack_public_path__ + "static/images/monet/page_title_background.png";